import { useEffect, useState } from "react";
import { isProtectedFileUrl, resolveFileUrl } from "@/lib/fileAccess";

/**
 * Image that supports data URLs and auth-protected /api/... logo paths.
 */
export default function AuthenticatedImage({ src, alt, className, fallback = null }) {
  const [displaySrc, setDisplaySrc] = useState(null);

  useEffect(() => {
    let blobUrl = null;
    let cancelled = false;

    if (!src) {
      setDisplaySrc(null);
      return undefined;
    }

    if (!isProtectedFileUrl(src)) {
      setDisplaySrc(src);
      return undefined;
    }

    setDisplaySrc(null);
    resolveFileUrl(src)
      .then((url) => {
        if (cancelled) {
          if (url?.startsWith("blob:")) URL.revokeObjectURL(url);
          return;
        }
        blobUrl = url;
        setDisplaySrc(url);
      })
      .catch(() => {
        if (!cancelled) setDisplaySrc(null);
      });

    return () => {
      cancelled = true;
      if (blobUrl?.startsWith("blob:")) URL.revokeObjectURL(blobUrl);
    };
  }, [src]);

  if (!displaySrc) return fallback;
  return <img src={displaySrc} alt={alt} className={className} />;
}
